import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import Navigation from "./navigation";

import { pStore, store } from "./redux/store";

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={pStore}>
        <Navigation />
      </PersistGate>
    </Provider>
  );
};

export default App;
